export var NEW_LINE_REGEX = /(\r\n|\r|\n)/;